import { eSubscriptionStatus } from 'src/providers/SubscriptionProvider/Subscription.enums';
import { COLLECTION_METHOD_SEND_INVOICE } from 'src/providers/SubscriptionProvider/useSeatPurchase.functions';
import { eSeatBillingMode } from './SeatCostNotice.types';

// Re-exported from the provider layer, which owns it, so existing importers keep
// working without a page owning a billing constant.
export { COLLECTION_METHOD_SEND_INVOICE } from 'src/providers/SubscriptionProvider/useSeatPurchase.functions';

/**
 * Which money-timing story this workspace gets.
 *
 * Trial wins over collection method: a trialing workspace is charged at trial end for
 * the total seat count whichever rail it is on, so promising an invoice in three days
 * would be wrong.
 *
 * Unknown remains unknown. The form routes to Subscription without promising a
 * charge time or asking for a card until the subscription rail can be resolved.
 */
export function resolveSeatBillingMode(input: {
  status?: eSubscriptionStatus;
  collectionMethod?: string | null;
}): eSeatBillingMode {
  if (input.status === eSubscriptionStatus.TRIAL) {
    return eSeatBillingMode.TRIALING;
  }

  if (input.collectionMethod === COLLECTION_METHOD_SEND_INVOICE) return eSeatBillingMode.INVOICE;
  if (input.collectionMethod === 'charge_automatically') return eSeatBillingMode.CARD;
  return eSeatBillingMode.UNKNOWN;
}

/**
 * Cents to a display string, following the convention already used across Settings:
 * the localized amount followed by the currency code, because the same symbol serves
 * several currencies here (MXN and USD both render as `$`).
 */
export function formatSeatAmount(amountCents: number, currency: string): string {
  const amount = (amountCents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: currency || 'USD',
  });

  return currency ? `${amount} ${currency}` : amount;
}
